module.exports = __webpack_public_path__ + "static/img/角色管理.98986b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/角色管理.png
// module id = NszH
// module chunks = 2